import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FieldValue } from '../../../../../@core/models/site-material-data.model';


@Component({
    selector: 'app-material-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.scss']
})

export class MaterialSliderComponent implements OnInit {
    @Input() positionField: number = undefined;
    @Input() field: number = undefined;
    @Input() slider: {
        disabled: boolean;
        invert: boolean;
        max: number;
        min: number;
        step: number;
        thumbLabel: boolean;
        tickInterval: number | 'auto';
    };
    @Input() onBuilder: string = '';
    @Output() setValueEvent = new EventEmitter<FieldValue>();
    value: number;
    constructor() {}
    ngOnInit() {
        this.value = this.slider.min;
        this.setValueEvent.emit({type: 'select', value: this.slider.min, required: false, position: this.field});
    }
    sliderValue($event) {
        this.setValueEvent.emit({type: 'select', value: this.value, required: false, position: this.field});
    }
}
